import { memo } from "react";

import { BTCheckbox } from "@btnet/core-components";
import { cn } from "@btnet/utilities-core";

import { type IGridCellRendererParams } from "commonComponents/utilities/AgGridReact/AgGridReact.types";

function columnCheckboxInternal(props: IGridCellRendererParams) {
    if (props.value) {
        return (
            <BTCheckbox
                id={`ag-col-checkbox.${props.colDef!.field!}.${props.node.rowIndex!}`}
                data-testid="ag-col-checkbox"
                checked={props.value || false}
                onChange={() => {}}
                disabled={props.colDef?.editable !== true}
                className={cn("ag-col-checkbox", props.className)}
            />
        );
    }
    return null;
}

export const columnCheckbox = memo(columnCheckboxInternal);
